import React, { useState, useEffect } from "react";

const ReportReverseTimer = (props: {
  initialTime: number;
  className?: string;
  onTimerZero?: () => void;
  loginUIConfig?:any
}) => {
  const [time, setTime] = useState<number>(props.initialTime);

  useEffect(() => {
    const timerId = setInterval(() => {
      setTime((prevTime) => {
        if (prevTime > 0) {
          return prevTime - 1;
        } else {
          clearInterval(timerId);
          // Invoke the callback when the timer reaches zero
          if (props.onTimerZero) props.onTimerZero();
          return 0;
        }
      });
    }, 1000);

    // Clear the interval when the component is unmounted
    return () => clearInterval(timerId);
  }, [props.onTimerZero]);

  useEffect(() => {
    // Reset the timer when the initial time prop changes
    setTime(props.initialTime);
  }, [props.initialTime]);

  // Format seconds into HH:mm:ss
  const formatTime = (seconds: number) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    if (!hours) {
      return `${String(minutes).padStart(2, "0")}:${String(
        remainingSeconds
      ).padStart(2, "0")}`;
    }
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}:${String(remainingSeconds).padStart(2, "0")}`;
  };

  return <span style={{color:"#24c6b1",fontWeight:500}} className={`${props.className}`}>{formatTime(time)}</span>;
};

export default ReportReverseTimer;
